export default "__VITE_ASSET__tkP4_2Pt__"